import React, { useState } from "react"
import { FileCheck } from "lucide-react"
import { Badge } from "@/components/ui/badge"
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card"
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog"

export default function CertificateFlipCard({ cert }) {
  const [flipped, setFlipped] = useState(false)

  const toggle = () => setFlipped((v) => !v)

  const onKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      toggle()
    }
  }

  return (
    <div className="w-full">
      <div
        className="w-full h-72 cursor-pointer"
        style={{ perspective: 1000 }}
      >
        <div
          className="relative w-full h-full"
          style={{
            transformStyle: "preserve-3d",
            transition: "transform 500ms",
            transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front */}
         {/* Front */}
<div
  role="button"
  aria-pressed={flipped}
  tabIndex={0}
  onClick={toggle}
  onKeyDown={onKey}
  className="absolute inset-0 flex flex-col p-6 bg-white border border-border rounded-xl shadow-sm hover:shadow-lg hover:scale-[1.02] transition-all overflow-hidden"
  style={{ backfaceVisibility: "hidden", zIndex: flipped ? 0 : 2 }}
>
  
  {/* Background Logo Watermark */}
  {cert.logo && (
    <img
      src={cert.logo}
      alt="background logo"
      className="absolute inset-0 m-auto w-40 h-40 object-contain opacity-10 blur-[1px] pointer-events-none"
    />
  )}

  {/* Content */}
  <div className="relative z-10 flex flex-col h-full">

    <div className="flex items-start gap-3">
      
      {/* Small Logo */}
      <div className="p-2 bg-slate-100 rounded-md flex items-center justify-center w-12 h-12">
        {cert.logo ? (
          <img
            src={cert.logo}
            alt="certificate logo"
            className="object-contain w-8 h-8"
          />
        ) : (
          <FileCheck className="text-blue-700 w-5 h-5" />
        )}
      </div>

      <div className="flex-1">
        <h4 className="font-semibold text-blue-700 text-[17px] leading-snug">
          {cert.title}
        </h4>

        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">
          {cert.description}
        </p>

        <div className="mt-3 flex items-center justify-between">
          <Badge className="bg-blue-900 text-white hover:bg-blue-900">
            {cert.category}
          </Badge>

          <span className="text-sm text-muted-foreground font-medium">
            {cert.year}
          </span>
        </div>
      </div>
    </div>

    <div className="mt-auto text-sm text-muted-foreground">
      Click to View Certificate
    </div>

  </div>
</div>

          {/* Back */}
          <div
            className="absolute inset-0 flex items-center justify-center bg-white border border-border rounded-xl overflow-hidden"
            style={{ transform: "rotateY(180deg)", backfaceVisibility: "hidden", zIndex: flipped ? 2 : 0 }}
            onClick={(e) => {
              // Allow clicks on the back to flip back unless the image (DialogTrigger) was clicked
              // If the click is directly on the image, let DialogTrigger handle it
              if (e.target.tagName !== "IMG") {
                toggle()
              }
            }}
          >
            <Dialog>
              <DialogTrigger asChild>
                <button className="w-full h-full focus:outline-none">
                  <img
                    src={cert.image}
                    alt={cert.title}
                    className="w-full h-full object-contain transition-transform duration-200 hover:scale-105"
                  />
                </button>
              </DialogTrigger>
              <DialogContent>
                <div className="w-full">
                  <img src={cert.image} alt={cert.title} className="w-full h-auto object-contain rounded-md" />
                </div>
              </DialogContent>
            </Dialog>
            <button
              onClick={(e) => {
                e.stopPropagation()
                toggle()
              }}
              className="absolute bottom-4 text-sm text-muted-foreground bg-white/0 px-3 py-1 rounded"
            >
              Back to Details
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
